module.exports = __webpack_public_path__ + "media/images/haccps-sumi-circle-mincho-red-76348eb4cb9d2d674c59611e53e2d56a.svg";